import { jsx as _jsx } from "react/jsx-runtime";
import { BKJIconComponentMap } from './BKJIcon.types.js';
export const BKJIcon = (props) => {
    const { iconName, fontSize = 24, secondaryColor, color, ...rest } = props;
    const IconComponent = BKJIconComponentMap[iconName];
    const _props = {
        'aria-hidden': true,
        fontSize,
        ...rest,
    };
    if (color)
        _props['color'] = color;
    if (secondaryColor)
        _props['secondaryColor'] = secondaryColor;
    return _jsx(IconComponent, { ..._props });
};
//# sourceMappingURL=BKJIcon.js.map